import React from "react";

// A legenda: um quadrado com a cor de cada serie e o texto na cor do texto, nunca na da serie (o
// amarelo e o aqua nao se leem como texto sobre o branco).
const Legend = ({ items }) => (
  <ul className="flex flex-wrap gap-x-4 gap-y-1 text-xs" style={{ color: "var(--color-text-secondary)" }}>
    {items.map((item) => (
      <li key={item.key} className="flex items-center gap-1.5">
        <span aria-hidden="true" className="inline-block w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: item.color }} />
        {item.label}
      </li>
    ))}
  </ul>
);

export default Legend;
